import { cn } from '@/lib/utils';
import { Card, CardContent, CardHeader } from '../card';
import { Skeleton } from '../Skeleton';
import { ShapeGroup } from './ShapeGroup';

interface MembershipCardsSkeletonProps {
  count?: number;
  label?: string;
  className?: string;
}

/** Membership offers: a card with a title and valid range, a feature line or two, price and a buy action. */
export function MembershipCardsSkeleton({
  count = 2,
  label,
  className,
}: MembershipCardsSkeletonProps) {
  return (
    <ShapeGroup label={label} className={cn('space-y-4', className)}>
      {Array.from({ length: count }, (_, i) => (
        <Card key={i} data-skeleton-card="">
          <CardHeader>
            <Skeleton.Line width="40%" className="h-5" />
            <Skeleton.Line width="55%" />
          </CardHeader>
          <CardContent className="space-y-4">
            <Skeleton.Line width="70%" />
            <Skeleton.Line width="45%" />
            <div className="flex items-center justify-between gap-4">
              <Skeleton.Line width="25%" className="h-5" />
              <Skeleton className="h-10 w-28" />
            </div>
          </CardContent>
        </Card>
      ))}
    </ShapeGroup>
  );
}
